import styled from 'styled-components';
import { TooltipSizeValue } from 'styled-system';

const getMobileMaxWidth = (size: TooltipSizeValue) => {
  switch (size) {
    case 's':
      return '25ch';
    case 'm':
      return '35ch';
    case 'l':
      return '40ch';
    default:
      return '35ch';
  }
};

const getDesktopMaxWidth = (size: TooltipSizeValue) => {
  switch (size) {
    case 's':
      return '33ch';
    case 'm':
      return '40ch';
    case 'l':
      return '50ch';
    default:
      return '40ch';
  }
};

export const BaseTooltip = styled.div<{
  size: TooltipSizeValue;
}>`
  background-color: ${({ theme }) => theme.brand.secondary.darker};
  padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M16}`};
  border-radius: ${({ theme }) => theme.borderRadius.s};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    max-width: ${({ size }) => getMobileMaxWidth(size)};
    margin: 0 8px;
  }
  max-width: ${({ size }) => getDesktopMaxWidth(size)};
  position: relative;
  // so the full tooltip container shows above everything else
  z-index: 20 !important;
`;
